import { Component, ViewChild } from "@angular/core";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { TranslateService } from "@ngx-translate/core";
import { App, Nav, Platform } from "ionic-angular";
import { environment } from "../environments/environment";
import { FirstRunPage, MainPage } from "./pages";
import { User } from "./providers";

@Component({
  template: `<ion-nav #content [root]="rootPage"></ion-nav>`,
})
export class MyApp {
  rootPage: any;

  @ViewChild(Nav) nav: Nav;

  pages: any[] = [
    { title: "Tutorial", component: "TutorialPage" },
    { title: "Welcome", component: "WelcomePage" },
    { title: "Tabs", component: "TabsPage" },
    { title: "Cards", component: "CardsPage" },
    { title: "Content", component: "ContentPage" },
    { title: "Login", component: "LoginPage" },
    { title: "Signup", component: "SignupPage" },
    { title: "Master Detail", component: "ListMasterPage" },
    { title: "Trainings", component: "TrainingsPage" },
    { title: "Menu", component: "MenuPage" },
    { title: "Settings", component: "SettingsPage" },
    { title: "Search", component: "SearchPage" },
    { title: "VouchersPage", component: "VouchersPage" },
  ];

  constructor(
    private translate: TranslateService,
    platform: Platform,
    app: App,
    user: User,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen
  ) {
    platform.ready().then(() => {
      this.statusBar.styleDefault();

      platform.registerBackButtonAction(() => {
        // Catches the active view
        let nav = app.getActiveNavs()[0];
        let activeView = nav.getActive();
        // Checks if can go back before show up the alert
        if (
          activeView.name !== "TutorialPage" &&
          activeView.name !== "TabsPage"
        ) {
          if (nav.canGoBack()) {
            nav.pop();
          }
        }
      });

      // Okay, so the platform is ready and our plugins are available.
      user.me().subscribe(
        (user) => {
          this.rootPage = MainPage;

          setTimeout(() => {
            this.splashScreen.hide();
          }, 1000);
        },
        (err) => {
          this.rootPage = FirstRunPage;

          setTimeout(() => {
            this.splashScreen.hide();
          }, 1000);
        }
      );
    });
    this.initTranslate();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang(environment.defaultLanguage);
    const browserLang = this.translate.getBrowserLang();

    if (browserLang) {
      if (browserLang === "zh") {
        const browserCultureLang = this.translate.getBrowserCultureLang();

        if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
          this.translate.use("zh-cmn-Hans");
        } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
          this.translate.use("zh-cmn-Hant");
        }
      } else {
        this.translate.use(this.translate.getBrowserLang());
      }
    } else {
      this.translate.use(environment.defaultLanguage); // Set your language here
    }
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts